import {
  IFileData,
  ISQLSeedingTranslator,
} from '@principle-theorem/practice-migrations/interfaces';
import { IProvider } from '@principle-theorem/shared';

export class ExactContactTranslator
  implements ISQLSeedingTranslator, IProvider<IFileData, string[]>
{
  matchingFilenames = ['ConvContact.csv'];
  commands = [`sed -i -e '1s/User/UserInitials/'`];

  canProvide(data: IFileData): boolean {
    return this.matchingFilenames.includes(data.fileName);
  }

  execute(data: IFileData): string[] {
    return this.commands.map((cmd) => `${cmd} ${data.filePath}`);
  }
}
